const NoResultsIllustration = () => (
  <svg width="65" height="61" viewBox="0 0 65 61" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.27689 9.68623C3.32789 12.2235 1.88849 23.7941 1.53742 29.2622C-1.20094 45.2943 4.90771 53.869 12.8068 57.478C20.7059 61.0869 30.7115 59.8839 40.8224 59.6652C50.9332 59.4465 54.8301 60.7589 60.2015 49.9319C65.5729 39.1049 64.5197 29.2622 62.5186 23.9035C60.5175 18.5447 53.2503 12.639 45.9831 6.5147C38.7159 0.390362 30.5009 -1.7969 24.6028 1.70272C18.7048 5.20234 9.96315 6.5147 6.27689 9.68623Z"
      fill="#F9FAFB"
    />
    <path
      d="M20.7548 38.9834L34.6675 14.8858C35.8725 12.7987 38.5413 12.0836 40.6284 13.2886L60.4795 24.7496C62.5666 25.9546 63.2817 28.6234 62.0767 30.7105L48.164 54.8081C46.959 56.8952 44.2902 57.6103 42.2031 56.4053L22.352 44.9442C20.2649 43.7392 19.5498 41.0705 20.7548 38.9834Z"
      fill="white"
      stroke="black"
      strokeWidth="0.218182"
    />
    <path
      d="M26.479 35.1329L36.6449 17.5251C37.2474 16.4815 38.5818 16.124 39.6253 16.7265L57.8508 27.249C58.8944 27.8515 59.2519 29.1859 58.6495 30.2294L48.4835 47.8373C47.8811 48.8808 46.5467 49.2384 45.5031 48.6359L27.2776 38.1133C26.2341 37.5109 25.8765 36.1765 26.479 35.1329Z"
      fill="#FEE9EF"
      stroke="black"
      strokeWidth="0.218182"
    />
    <path
      d="M35.9696 49.7163L24.3883 43.0298C23.4075 42.4636 23.0715 41.2095 23.6377 40.2287C24.204 39.248 25.4581 38.912 26.4388 39.4782L38.0201 46.1647C39.0009 46.7309 39.3369 47.985 38.7707 48.9658C38.2044 49.9465 36.9504 50.2825 35.9696 49.7163Z"
      stroke="black"
      strokeWidth="0.218182"
    />
    <path
      d="M9.81812 48.0329V12.0329C9.81812 9.62292 11.7718 7.66925 14.1818 7.66925H40.4562C41.7145 7.66925 42.9116 8.21244 43.7402 9.15941L47.4657 13.4172C48.1617 14.2126 48.5454 15.2337 48.5454 16.2906V48.0329C48.5454 50.4429 46.5917 52.3965 44.1818 52.3965H14.1818C11.7718 52.3965 9.81812 50.4429 9.81812 48.0329Z"
      fill="white"
      stroke="black"
      strokeWidth="0.218182"
    />
    <path
      d="M13.5268 39.9561V14.1016C13.5268 12.8966 14.5037 11.9197 15.7086 11.9197H42.4359C43.6409 11.9197 44.6177 12.8966 44.6177 14.1016V39.9561C44.6177 41.1611 43.6409 42.1379 42.4359 42.1379H15.7086C14.5037 42.1379 13.5268 41.1611 13.5268 39.9561Z"
      fill="#FEE9EF"
      stroke="black"
      strokeWidth="0.218182"
    />
    <path
      d="M22.2545 31.4529C23.0621 30.5074 25.5253 28.6165 28.9172 28.6165C32.3091 28.6165 34.9069 30.5074 35.7818 31.4529"
      stroke="black"
      strokeWidth="0.218182"
    />
    <circle cx="22.7997" cy="24.7927" r="0.763636" fill="#111928" />
    <circle cx="35.018" cy="24.7927" r="0.763636" fill="#111928" />
    <path
      d="M32.5091 49.123H16.1455C14.7597 49.123 13.6364 47.9996 13.6364 46.6139C13.6364 45.2282 14.7597 44.1048 16.1455 44.1048H32.5091C33.8948 44.1048 35.0182 45.2282 35.0182 46.6139C35.0182 47.9996 33.8948 49.123 32.5091 49.123Z"
      fill="#FEE9EF"
      stroke="black"
      strokeWidth="0.218182"
    />
    <path
      d="M45.6059 1.99811C46.3828 2.0881 47.1128 2.36482 47.7442 2.78796L48.6205 5.69392L45.4871 7.41932C45.3985 7.46807 45.3276 7.55309 45.3023 7.65875C45.2843 7.73413 45.2871 7.81155 45.3128 7.88333L45.3466 7.95302L48.0654 12.4498C48.1634 12.612 48.369 12.6818 48.5477 12.603C48.7022 12.5348 48.7908 12.3782 48.7759 12.2165L48.7635 12.1468L47.722 8.42802L51.3534 6.84001C51.5044 6.77658 51.593 6.62152 51.5833 6.46519L51.5824 6.46492L51.4359 4.24992C52.4205 4.02041 53.4667 4.1043 54.4146 4.50746L54.6087 4.59588C56.7359 5.60674 57.8166 7.99823 57.1676 10.2509L57.1124 10.4423C56.7507 11.6977 55.914 12.7609 54.7826 13.4074L54.5528 13.5312L46.9703 17.3692C46.6803 17.5158 46.3438 17.5474 46.0294 17.4568C45.7151 17.3662 45.4477 17.1605 45.2802 16.8823L40.9019 9.5984C40.1804 8.40176 39.9924 6.96003 40.378 5.62116L40.4332 5.42973C41.0822 3.17711 43.2692 1.72651 45.6059 1.99811Z"
      fill="#ED3A56"
      stroke="black"
      strokeWidth="0.218182"
    />
    <path d="M49.0907 1.77799L48.5452 0.0325317" stroke="black" strokeWidth="0.218182" />
    <path d="M50.7455 1.922L51.2671 0.16925" stroke="black" strokeWidth="0.218182" />
    <path d="M51.9936 2.4299L53.5095 1.40704" stroke="black" strokeWidth="0.218182" />
    <path
      d="M56.4657 8.63156C56.0486 6.69045 54.3205 5.59446 53.28 5.23762C53.1316 5.18674 52.975 5.26806 52.9168 5.4137C52.8524 5.57455 52.9306 5.75719 53.0899 5.82515C53.2986 5.91414 53.5608 6.03065 53.7821 6.1413C54.9314 6.71594 55.519 7.87191 55.7518 8.64823C55.816 8.86222 55.9758 9.06476 56.1891 8.99829C56.3261 8.9556 56.4959 8.77184 56.4657 8.63156Z"
      fill="white"
      fillOpacity="0.5"
    />
    <path
      d="M3.19824 40.1492C3.56094 40.9738 4.22035 41.6323 5.04492 41.9949L5.62012 42.2479L5.04492 42.5008C4.2203 42.8635 3.56093 43.5229 3.19824 44.3475L2.94531 44.9227L2.69238 44.3475C2.32972 43.5229 1.67124 42.8635 0.84668 42.5008L0.270508 42.2479L0.84668 41.9949C1.67111 41.6323 2.32971 40.9737 2.69238 40.1492L2.94531 39.5731L3.19824 40.1492Z"
      fill="#FDC8D3"
      stroke="black"
      strokeWidth="0.218182"
    />
    <path
      d="M59.5063 15.6937C59.913 16.6182 60.6512 17.3573 61.5757 17.764L61.6919 17.8148L61.5757 17.8665C60.6514 18.2731 59.913 19.0115 59.5063 19.9359L59.4546 20.0521L59.4038 19.9359C58.9971 19.0114 58.258 18.2731 57.3335 17.8665L57.2163 17.8148L57.3335 17.764C58.2581 17.3573 58.9972 16.6182 59.4038 15.6937L59.4546 15.5765L59.5063 15.6937Z"
      fill="#FDC8D3"
      stroke="black"
      strokeWidth="0.218182"
    />
  </svg>
);

export default NoResultsIllustration;
